module.exports = __webpack_public_path__ + "static/media/Scape_logo.dc0c143c.png";